/*! @azure/msal-browser v5.19.0 2026-08-18 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "5.19.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
